import React, { useEffect, useRef, useState } from 'react';
import { isVideoUrl } from 'src/components/DesignSystem/ModernTheme/utils/videoUtility';
import { CONTAINER_TYPE, LAYOUT_TYPE } from '../../constant';
import InstagramVideoComp from './InstagramVideoComp';
import RenderInstaModal from './RenderInstaModal';
import { commonApiHeader } from '../utils';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import axios from 'axios';
import { ENDPOINT } from 'src/config/endpoints';
import { RootState } from 'src/redux/reducers';
import { useSelector } from 'react-redux';
import { toastNotifyError } from 'src/components/Common/Toast';
import { GlobalCfeLoader } from 'src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader';
import { ACTION_TYPE, MEDIA_TYPE } from './constant';
import { useListPresentationContextData } from '../../context/ListPresentationContext';

export function InstagramReels() {
  const data = useListPresentationContextData();
  const { isMobile, listPresentationConfig } = data.state;
  const { getConfigsAndUtils } = data.utilities;
  const { oneGridCellGeometry, containerTracks, isLayoutCarousel } = getConfigsAndUtils().generalValues;

  const { storeId } = useSelector((state: RootState) => ({
    storeId: state.storeReducer.store.store_id,
  }));
  const {
    authToken,
    widgetContextState: { fetchingInstaData, globalStyle },
    widgetContextActions: { setInstaUserDetail }
  } = useWidgetDndContextData();

  const videoRefs = useRef<Record<number, HTMLVideoElement>>({});
  const [modalConfig, setModalConfig] = useState({
    showModal: false,
    post: {},
    type: '',
    userDetails: {},
    currIndex: 0
  })
  const [instaDataFromApi, setInstaDataFromApi] = useState({
    media: [],
    user: {}
  })
  const isLayout2 = listPresentationConfig.layoutName === LAYOUT_TYPE.layout2;
  const numOfItemToShow = containerTracks?.numColumns * containerTracks?.numRows;
  const updatedInstaData = isLayoutCarousel ? instaDataFromApi?.media : instaDataFromApi?.media?.slice(0, numOfItemToShow);

  async function getInstaDataFromApi() {
    const apiHeader = commonApiHeader(authToken);
    const instaApiForCfe = ENDPOINT.INSTAGRAM.getInstaDataOnCfe(storeId);
    try {
      const response = await axios.get(instaApiForCfe, apiHeader);
      const updatedResponse = JSON.parse(response?.data?.data);
      setInstaUserDetail(updatedResponse || {})
      setInstaDataFromApi(updatedResponse)
    }
    catch (err) {
      toastNotifyError(err)
    }
  }

  useEffect(() => {
    getInstaDataFromApi();
  }, [])

  function showZigZaglayout() {
    if (isMobile && listPresentationConfig.numColumnsMobile === 1) {
      return false;
    }
    return true;
  }

  function checkForIndexing(index: number) {
    if (!isMobile && listPresentationConfig.layoutType === CONTAINER_TYPE.GRID) {
      const currentIndexOfImage = index % listPresentationConfig.numColumnsDesktop;
      if (currentIndexOfImage % 2 !== 0) {
        return true;
      }
      return false;
    }
    else if (index % 2 === 0) {
      return false;
    }
    return true;
  }

  function handleMediaClick(post, type, index) {
    const updatedModalConfig = { ...modalConfig };
    updatedModalConfig.post = post;
    updatedModalConfig.showModal = true;
    updatedModalConfig.type = type;
    updatedModalConfig.userDetails = instaDataFromApi?.user;
    updatedModalConfig.currIndex = index
    setModalConfig(updatedModalConfig);
  }

  function handleModalPost(type: string) {
    const updatedModalConfig = { ...modalConfig };
    const { currIndex } = updatedModalConfig
    if (type === ACTION_TYPE.PREVIOUS && currIndex >= 1) {
      const currentPost = instaDataFromApi?.media?.[currIndex - 1];
      const type = isVideoUrl(currentPost?.parent_media?.media_url) ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.IMAGE
      if (currentPost?.child_media?.length) {
        handleMediaClick(currentPost, '', currIndex - 1)
      }
      else {
        handleMediaClick(currentPost, type, currIndex - 1)
      }
    }
    else if (type === ACTION_TYPE.NEXT && currIndex < (instaDataFromApi?.media?.length - 1)) {
      const currentPost = instaDataFromApi?.media?.[currIndex + 1];
      const type = isVideoUrl(currentPost?.parent_media?.media_url) ? MEDIA_TYPE.VIDEO : MEDIA_TYPE.IMAGE
      if (currentPost?.child_media?.length) {
        handleMediaClick(currentPost, '', currIndex + 1)
      }
      else {
        handleMediaClick(currentPost, type, currIndex + 1)
      }
    }

  }


  function renderImages(url, post, index) {
    return (
      <div onClick={() => handleMediaClick(post, MEDIA_TYPE.IMAGE, index)} className='tw-h-[100%] tw-w-[100%]'>
        <img
          width={'100%'}
          loading='lazy'
          height={'100%'}
          src={url} className="tw-h-full tw-w-full tw-max-w-full tw-object-cover" />
      </div>
    )
  }

  function renderVideos(url, index, post) {
    return (
      <div onClick={() => handleMediaClick(post, MEDIA_TYPE.VIDEO, index)} className='tw-h-[100%] tw-w-[100%]'>
        <InstagramVideoComp
          oneGridCellGeometry={oneGridCellGeometry}
          post={url}
          index={index}
          videoRef={videoRefs}
        />
      </div>
    )
  }

  return (
    <>
      {
        !fetchingInstaData ?
          updatedInstaData?.map((post, index) => {
            return (
              <>
                <div
                  key={index}
                  style={{
                    width: oneGridCellGeometry.width + 'px',
                    height: oneGridCellGeometry.height + 'px',
                    minWidth: oneGridCellGeometry.width + 'px',
                  }}
                  className={`${(isLayout2 && showZigZaglayout()) ? checkForIndexing(index) ? 'tw-relative tw-bottom-20' : '' : ''}`}
                >
                  {
                    isVideoUrl(post?.parent_media?.media_url) ? renderVideos(post?.parent_media?.media_url, index, post) : renderImages(post?.parent_media?.media_url, post, index)}
                </div>
              </>
            );
          }) : <GlobalCfeLoader
            type={globalStyle?.appLoader?.loaderId || 'ellipsis'}
            color={globalStyle?.appLoader?.color}
          />
      }
      {modalConfig.showModal &&
        <RenderInstaModal
          config={modalConfig}
          setConfig={setModalConfig}
          handlePrevPost={() => handleModalPost(ACTION_TYPE.PREVIOUS)}
          handleNextPost={() => handleModalPost(ACTION_TYPE.NEXT)}
        />}
    </>
  )
}


